import React from "react";
import PropTypes from "prop-types";

const BundleItemInfo = ({ infoKey, infoValues }) => (
  <div className="flex flex-row space-x-2">
    <span>{infoKey}</span>
    <div className="flex flex-col">
      {infoValues.map((value) => (
        <span className="font-bold">{value}</span>
      ))}
    </div>
  </div>
);

BundleItemInfo.propTypes = {
  infoKey: PropTypes.string,
  infoValues: PropTypes.array
};

BundleItemInfo.defaultProps = {
  infoKey: null,
  infoValues: null
};

export default BundleItemInfo;
